'use strict';

angular.module('shiftTraderApp')
  .service('DaysOffManagementModalService', ['$log', '$rootScope', 'Session', 'TimeService', 'DaysOffStore', 'GlobalRxFeed',
    function ($log, $rootScope, Session, TimeService, DaysOffStore, GlobalRxFeed) {
    var currentDate;
    var selectedDayOff;
    var selectedDayOffId;
    var departmentMode = false;
    var departmentsSummaryData;

    var that = this;

    this.dateChangeEventName = 'sa:daysOffManagementModalService:dateChange';
    this.dataChangeEventName = 'sa:daysOffManagementModalService:dataChange';
    this.selectedDayOffChangedEventName = 'sa:daysOffManagementModalService:selectedDayOffChanged';
    this.toggleDepartmentModeEventName = 'sa:daysOffManagementModalService:toggleDepartmentMode';
    this.departmentSummaryDataChangeEventName = 'sa:daysOffManagementModalService:departmentSummaryDataChanged';

    function fireDateChangeEvent() {
      console.log('currentDateEvent', currentDate.format());
      $rootScope.$broadcast(that.dateChangeEventName, moment(currentDate));
      GlobalRxFeed.push('app-event', 'daysoff-management-modal-date-change', { date: moment(currentDate).format('YYYY-MM-DD') })
    }

    function fireDataChangeEvent() {
      console.log('currentDataEvent', currentDate.format());
      $rootScope.$broadcast(that.dataChangeEventName, moment(currentDate));
    }

    function fireSelectedDayOffChangedEvent() {
      console.log('selectedDayOffChangedEvent', selectedDayOffId);
      $rootScope.$broadcast(that.selectedDayOffChangedEventName, selectedDayOffId);
    }

    function fireDepartmentModeEvent() {
      $rootScope.$broadcast(that.toggleDepartmentModeEventName, departmentMode);
    }

    function fireDepartmentsSummaryDataChanged() {
      $rootScope.$broadcast(that.departmentSummaryDataChangeEventName, departmentMode);
    }

    this.setCurrentDate = function(dt) {
      console.log('setCurrentDate', dt.format());
      var triggerChange = true;

      // if (!currentDate || !currentDate.isSame(dt)) {
      //   triggerChange = true;
      // }

      currentDate = moment(dt);

      if (triggerChange) {
        fireDateChangeEvent();
      }

      return moment(currentDate);
    };

    this.getCurrentDate = function() {
      return moment(currentDate);
    };

    this.setDepartmentsSummaryData = function(data) {
      departmentsSummaryData = data;
      fireDepartmentsSummaryDataChanged()
    };

    this.setDepartmentMode = function(mode) {
      departmentMode = !!mode;
      fireDepartmentModeEvent();
    };

    this.getDepartmentsSummaryData = function() {
      return departmentsSummaryData;
    };

    this.toggleDepartmentMode = function() {
      departmentMode = !departmentMode;
      fireDepartmentModeEvent();
    };

    this.getDepartmentMode = function() {
      return departmentMode;
    };

    this.getCurrentWeek = function() {
      return TimeService.getWeekTwixFromMoment(moment(currentDate));
    };

    this.getCurrentWeekDayTwixes = function() {
      var week = that.getCurrentWeek();

      return _.map(_.range(7), function(dayNum) {
        return moment(week.start).add(dayNum, 'days').twix(moment(week.start).add(dayNum + 1, 'days'));
      });
    };

    this.getDaysOffIntersectingDate = function(dt) {
      var dtTwix = TimeService.getDayTwixFromDate(dt);

      console.log('dtDtwix', dtTwix.format(), 'from', dt.format());

      return DaysOffStore.getDaysOffIntersectingDate(dtTwix.start);

      //return _(allDaysOff).where(function(dayOff) {
      //  return dayOff.range_twix.overlaps(dtTwix) &&
      //    Math.abs(dayOff.range_twix.intersection(dtTwix).length('minutes')) > 0 &&
      //    dayOff.range_twix.end.isAfter(moment(dt).add(Session.getWorkDayStartHour(), 'hours'), 'minute');
      //}).value();
    };

    this.getDaysOffIntersectingCurrentDate = function() {
      console.log('getDayOffIntersectingCurrentDate', currentDate.format());

      return DaysOffStore.getDaysOffIntersectingDate(moment(currentDate));
    };

    this.setSelectedDayOffId = function(dayOffId) {
      console.log('setSelectedDayOff', dayOffId);
      selectedDayOffId = dayOffId;
      selectedDayOff = DaysOffStore.getRecordById(dayOffId);
      console.log('result: ', selectedDayOff);

      if (selectedDayOff) {
        fireSelectedDayOffChangedEvent();
        return selectedDayOff;
      } else {
        selectedDayOff = undefined;
        fireSelectedDayOffChangedEvent();
        return false;
      }
    };

    this.getSelectedDayOff = function() {
      return DaysOffStore.getRecordById(selectedDayOffId);
    };

  }]);
